import validator from 'validator';
import { normalizeMsisdn, removeNonDigitCharacters } from 'utils/helpers';

const updateDataErrors = {
  fieldRequired: 'update_customer_data.errors.fieldRequired',
};

const msisdnRegex = /^04\d{8}$/;
const otpAndPostcodeRegex = /^\d{4}$/;

function phoneValidation(msisdn) {
  return !validator.matches(removeNonDigitCharacters(msisdn), msisdnRegex);
}

function emailValdation(email) {
  return !validator.isEmail(email);
}

function otpValidation(otp) {
  return !validator.matches(otp, otpAndPostcodeRegex);
}

function postcodeValidation(postcode) {
  return !validator.matches(postcode.toString(), otpAndPostcodeRegex);
}

export default function updateDataValidation(values, form) {
  const isOtpRequired = !form.authentication.expiredData.verifiedMsisdnChangeRequestExists;
  const errors = {};

  if (!values.msisdn) {
    errors.msisdn = updateDataErrors.fieldRequired;
  } else if (phoneValidation(values.msisdn)) {
    errors.msisdn = 'errors.field.msisdn';
  }

  if (!values.email) {
    errors.email = updateDataErrors.fieldRequired;
  } else if (emailValdation(values.email)) {
    errors.email = 'errors.field.email';
  }

  if (
    values.msisdn
    && !values.otp
    && (normalizeMsisdn(values.msisdn) !== form.authentication.msisdn
    || form.authentication.msisdnPending
    || isOtpRequired)
  ) {
    errors.otp = updateDataErrors.fieldRequired;
  } else if (values.otp && otpValidation(values.otp)) {
    errors.otp = 'errors.field.otp';
  }

  // 'ADDRESS'
  if (!values.street) {
    errors.street = updateDataErrors.fieldRequired;
  }

  if (!values.floor) {
    errors.floor = updateDataErrors.fieldRequired;
  }

  if (!values.city) {
    errors.city = updateDataErrors.fieldRequired;
  }

  if (!values.province) {
    errors.province = updateDataErrors.fieldRequired;
  }

  if (!values.postcode) {
    errors.postcode = updateDataErrors.fieldRequired;
  } else if (postcodeValidation(values.postcode)) {
    errors.postcode = 'errors.field.postcode';
  }

  if (!values.updateDataConfirmation) {
    errors.updateDataConfirmation = updateDataErrors.fieldRequired;
  }

  return errors;
}
